import React, { StrictMode, useEffect, useMemo, useState } from "react";
import { Component } from "react";
import {
  BigCalendarEvent,
  GoogleCalendarImporter,
  GoogleCalendarFeed,
} from "./GoogleCalendarImporter";
import { CALENDARS } from "./CALENDARS";
import moment from "moment";

export interface HfcsCalendarFeedProps {
  events: BigCalendarEvent[];
  slug: string;
}

class HfcsCalendarFeed extends React.Component<HfcsCalendarFeedProps, any> {
  public render() {
    return (
      <div id="calendar-events-container">
        <div id="calendar-events">
          {this.props.events.map((event) => {
            const start = moment(event.start);
            const end = moment(event.end).subtract(1, "minute");
            const multiDay = !start.startOf("day").isSame(end.startOf("day"));

            return (
              <div className="event-wrap" key={`${event.start}${event.end}`}>
                <div className="event-date">
                  <div className="event-date-month">{start.format("MMM")}</div>
                  <div className="event-date-day">{start.format("D")}</div>
                  {multiDay && (
                    <div className="event-dadte-end-day">
                      – {end.format("MMM D")}
                    </div>
                  )}
                </div>
                <h3>{event.title}</h3>
              </div>
            );
          })}
        </div>
        <a className="btn" href={`/calendar/?calendar_feed=${this.props.slug}`}>
          See Full Calendar
        </a>
      </div>
    );
  }
}

const Feed = (props: { feed: string }) => {
  const [loading, setLoading] = useState(true);
  const [events, setEvents] = useState([] as BigCalendarEvent[]);
  const importer = useMemo(
    () => new GoogleCalendarImporter("AIzaSyBidfnQVzSwa1549oZxkm9KmT4bdui5oes"),
    []
  );

  useEffect(() => {
    const setSelected = async (feed: GoogleCalendarFeed) => {
      setLoading(true);

      const scopedEvents =
        props.feed === "hfcs"
          ? []
          : await importer.getCalendar(feed, [
              `timeMin=${moment().startOf("day").toISOString()}`,
            ]);

      const hfcsEvents = await importer.getCalendar(CALENDARS[0], [
        `timeMin=${moment().startOf("day").toISOString()}`,
      ]);

      // sort events by start date
      const sortedEvents = [...scopedEvents, ...hfcsEvents].sort((a, b) => {
        return moment(a.start).isBefore(moment(b.start)) ? -1 : 1;
      });

      setLoading(false);
      setEvents(sortedEvents);
    };

    setSelected(CALENDARS.find((x) => x.slug === props.feed) || CALENDARS[0]);
  }, [props.feed, importer]);

  return (
    <StrictMode>
      <div id="calendar-feed">
        {loading && <div className="hfcs-loading" />}
        {!loading && (
          <HfcsCalendarFeed events={events.slice(0, 3)} slug={props.feed} />
        )}
      </div>
    </StrictMode>
  );
};

export default Feed;
